function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { elsterDocxUtils, Table, TableRow, VerticalAlign, WidthType } from '../utils/elster_docx_utils';
import i18n from 'i18next';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date/dateUtils';
import formatDEFrameworkValue from '@rd-web-markets/shared/dist/util/helpers/formatDEFrameworkValue';
import { leftColumnWidth, rightColumnWidth, tableFullWidth, borders, tableMargins } from '../styles/elsterDocStyles';
const generalTable = (data, tableInstructions) => {
  const {
    t
  } = i18n;
  const {
    createParagraph,
    createTableCell
  } = elsterDocxUtils;
  const cellMainOptions = {
    borders: borders,
    verticalAlign: VerticalAlign.CENTER
  };
  const formatByFieldType = (value, fieldType) => {
    if (fieldType === 'yes_no') {
      if (value === null || value === undefined) {
        return '';
      }
      return value === true ? t('yes') : t('no');
    }
    if (value === null || value === undefined || value === '') {
      return '';
    }
    if (fieldType === 'date') {
      var _createTimezonedDate;
      const formattedDate = (_createTimezonedDate = createTimezonedDate(value)) === null || _createTimezonedDate === void 0 ? void 0 : _createTimezonedDate.toCustomLocaleDateString();
      return formattedDate || '';
    }
    if (fieldType === 'decimal') {
      return formatDEFrameworkValue(String(value));
    }
    if (fieldType === 'integer') {
      const parsed = Number(value);
      if (Number.isNaN(parsed)) {
        return '';
      }
      return Math.trunc(parsed).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return value.toString();
  };
  const createLeftCell = tableInstruction => {
    return createTableCell(cellMainOptions, leftColumnWidth, [createParagraph(t(tableInstruction.translationKey), {
      style: 'mainText'
    })]);
  };
  const createRightCell = tableInstruction => {
    const value = data[tableInstruction.dataKey];
    const formattedValue = formatByFieldType(value, tableInstruction.fieldType);
    return createTableCell(cellMainOptions, rightColumnWidth, [createParagraph(tableInstruction.shouldTranslateRightCell ? t(value) : formattedValue, {
      style: 'mainText'
    })]);
  };
  const createRow = tableInstruction => [createLeftCell(tableInstruction), createRightCell(tableInstruction)];
  const tableRows = tableInstructions.map(tableInstruction => {
    return new TableRow({
      children: createRow(tableInstruction)
    });
  });
  const table = new Table({
    width: {
      size: tableFullWidth,
      type: WidthType.DXA
    },
    columnWidths: [leftColumnWidth, rightColumnWidth],
    margins: _objectSpread({}, tableMargins),
    rows: tableRows
  });
  return table;
};
export default generalTable;